import {guestTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = guestTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const guestReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default guestReducer;
